export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ22.3a71357c.mp3";